<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }

  @if (somenteLeitura) {
    <span class="campo-valor-leitura">{{ valor || '--' }}</span>
  } @else if (tipo === 'senha') {
    <div class="campo-input-wrapper">
      <input
        class="campo-input-base campo-input-com-icone-direita"
        [class.campo-input-erro]="erro"
        [type]="tipoInputAtual"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [value]="valor"
        autocomplete="new-password"
        (input)="aoDigitar($any($event.target).value)"
        (blur)="aoTocar()" />
      <button type="button" class="campo-input-icone-direita" tabindex="-1"
              [attr.title]="senhaVisivel() ? 'Ocultar senha' : 'Mostrar senha'"
              (click)="alternarSenhaVisivel()">
        <img src="./assets/icones/redesign/inputs/password-eye.svg" alt="" />
      </button>
    </div>
  } @else {
    <input
      class="campo-input-base"
      [class.campo-input-erro]="erro"
      type="text"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="valor"
      [attr.autocomplete]="autocomplete"
      (input)="aoDigitar($any($event.target).value)"
      (blur)="aoTocar()" />
  }

  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
